import React, { Fragment, useState, useEffect } from "react";
import Select from "react-select";
import { Dropdown } from "react-bootstrap";
import { Form, FormGroup, Label, Input } from "reactstrap";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import {
  Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup,
} from "react-bootstrap";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
//** Import Image */
import food1 from "./../../../../images/foods/food1.jpg";
import food2 from "./../../../../images/foods/food2.jpg";
import food4 from "./../../../../images/foods/food4.jpg";
import food9 from "./../../../../images/foods/food9.png";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Typography from "@material-ui/core/Typography";
import FoodMenuForm from "./FoodMenuForm";
import VariantItemForm from "./VariantItemForm";
import AddOnForm from "./AddOnForm";
import { Accordion } from '@mui/material';
// import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import {
  saveoutletDetails, getRoleMaster, getoutletListMaster, addOutletSubMenuItem, UpdateOutletSubMenuItem,
  gettstaffListMaster, getMenuMasterList, saveMainMenuName, updatePWDstaffDetails, saveSubMenuName
} from "../../../../apiservicescall/api";
import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#00b53b"
    // backgroundColor: "red"
  },
  rootExpanded: {
    flexGrow: 1,
    width: "100%",
    // backgroundColor: "#00b53b"
    // backgroundColor: "blue"
  }
}));
const MenuAvailablity = (props) => {

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const [menu, setMenu] = useState([
    {
      mainmenu: "Breakfast",
      isavailable: true,
      submenu: [
        {
          subitem: "Idly",
          price: "8 Rs",
          foodtype: "Veg",
          qty: "3Pc",
          img: "../image/plate6.png",
          nestedsubmenuitem: false,
          isavailable: true,
        },
        {
          subitem: "Pongal",
          price: "12 Rs",
          foodtype: "Veg",
          qty: "3Pc",
          img: "https://picsum.photos/200",
          isavailable: false,
        },
        {
          subitem: "Poori",
          price: "25 Rs",
          foodtype: "Veg",
          qty: "2Sets",
          img: "https://picsum.photos/200",
          isavailable: true,
        },
        {
          subitemname: "Dosa",
          nestedsubmenuitem: true,
          isavailable: true,
          subitemvarieties: [
            {
              subitemname: "PodiDosa",
              price: "25 Rs",
              foodtype: "Veg",
              qty: "3Pc",
              img: "../image/plate6.png",
              isavailable: true,
            },
            {
              subitemname: "OnionDosa",
              price: "35 Rs",
              foodtype: "Veg",
              qty: "2Pc",
              img: "https://picsum.photos/200",
              isavailable: true,
            },
            {
              subitemname: "PlainDosa",
              price: "40 Rs",
              foodtype: "Veg",
              qty: "1Pc",
              img: "https://picsum.photos/200",
              isavailable: true,
            },
          ],
        },
      ],
    },
    {
      mainmenu: "Lunch",
      submenu: [
        {
          subitem: "Meals",
          price: "90 Rs",
          foodtype: "Veg",
          qty: "1KG",
          img: "../image/plate6.png",
          nestedsubmenuitem: false,
          isavailable: true,
        },

        {
          subitem: "Variety Rice",
          nestedsubmenuitem: true,
          isavailable: false,
          subitemvarieties: [
            {
              subitem: "Lemon Rice",
              price: "30 Rs",
              foodtype: "Veg",
              qty: "1 Plate",
              img: "https://picsum.photos/200",
              isavailable: true,
            },
            {
              subitem: "Tomato Rice",
              price: "35 Rs",
              foodtype: "Veg",
              qty: "2 Plate",
              img: "../image/plate6.png",
              isavailable: true,
            },
            {
              subitem: "Curd Rice",
              price: "25 Rs",
              foodtype: "Veg",
              qty: "1 Plate",
              img: "../image/plate6.png",
              isavailable: true,
            },
            {
              subitem: "Sambar Rice",
              price: "30 Rs",
              foodtype: "Veg",
              qty: "2 Plate",
              img: "https://picsum.photos/200",
              isavailable: false,
            },
          ],
        },
      ],
    },
    {
      mainmenu: "beverages",
      submenu: [
        {
          subitem: "Tea",
          price: "15 Rs",
          foodtype: "Veg",
          qty: "150Ml",
          img: "https://picsum.photos/200",
          nestedsubmenuitem: false,
          isavailable: true,
        },
        {
          subitem: "Coffee",
          price: "20 Rs",
          foodtype: "Veg",
          qty: "250Ml",
          img: "../image/plate6.png",
          isavailable: true,
        },
        {
          subitem: "Black Tea",
          price: "20 Rs",
          foodtype: "Veg",
          qty: "150Ml",
          img: "https://picsum.photos/200",
          isavailable: true,
        },
        {
          subitem: "Juice",
          nestedsubmenuitem: true,
          isavailable: false,
          juicevarities: [
            {
              subitem: "Rose Milk",
              price: "30 Rs",
              foodtype: "Veg",
              qty: "250Ml",
              img: "https://picsum.photos/200",
              isavailable: true,
            },
            {
              subitem: "Badam Milk",
              price: "35 Rs",
              foodtype: "Veg",
              qty: "125Ml",
              img: "https://picsum.photos/200",
              isavailable: true,
            },
            {
              subitem: "Fresh Juice",
              price: "40 Rs",
              foodtype: "Veg",
              qty: "225Ml",
              img: "../image/plate6.png",
              isavailable: true,
            },
          ],
        },
        {
          subitem: "Soup",
          nestedsubmenuitem: true,
          isavailable: true,
          soupvarities: [
            {
              subitem: "Mushroom Soup",
              price: "35 Rs",
              foodtype: "Veg",
              qty: "250Ml",
              img: "https://picsum.photos/200",
              isavailable: false,
            },
            {
              subitem: "chicken Soup",
              price: "45 Rs",
              foodtype: "Non-Veg",
              qty: "125Ml",
              img: "https://picsum.photos/200",
              isavailable: true,
            },
            {
              subitem: "Sweet Corn Juice",
              price: "30 Rs",
              foodtype: "Veg",
              qty: "225Ml",
              img: "https://picsum.photos/200",
              isavailable: true,
            },
          ],
        },
      ],
    },
    {
      mainmenu: "Dinner",
      submenu: [
        {
          subitem: "Idly",
          price: "8 Rs",
          foodtype: "Veg",
          qty: "3Pc",
          img: "https://picsum.photos/200",
          nestedsubmenuitem: false,
          isavailable: true,
        },

        {
          subitem: "Dosa",
          nestedsubmenuitem: true,
          isavailable: true,
          vara: [
            {
              subitem: "PodiDosa",
              price: "25 Rs",
              foodtype: "Veg",
              qty: "3Pc",
              img: "https://picsum.photos/200",
              isavailable: true,
            },
            {
              subitem: "OnionDosa",
              price: "35 Rs",
              foodtype: "Veg",
              qty: "2Pc",
              img: "https://picsum.photos/200",
              isavailable: true,
            },
            {
              subitem: "PlainDosa",
              price: "40 Rs",
              foodtype: "Veg",
              qty: "1Pc",
              img: "https://picsum.photos/200",
              isavailable: true,
            },
          ],
        },
      ],
    },
  ]);

  const listItem = ["Breakfast", "Lunch", "Dinner", "Dosas"];
  const [menuFoodItemModal, setMenuFoodItemModal] = useState(false);
  const [subMenuModal, setSubMenuModal] = useState(false);
  const [mainMenuModal, setMainMenuModal] = useState(false);
  const [isView, setIsview] = useState(false);
  const [isedit, setIsedit] = useState(false);
  const [tempModalPopupValue, setTempModalPopupValue] = useState();
  const [openImagePopup, setOpenImagePopup] = useState();
  //stepper//
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const [completed, setCompleted] = useState(new Set());
  const [skipped, setSkipped] = useState(new Set());

  const [category, setCategory] = useState([]);

  const [variant, setVariant] = useState([
    { label: "Size", value: "Size" },
    { label: "Quantity", value: "Quantity" },
    { label: "Rice", value: "Rice" },
  ]);

  const [typeadd, setTypeadd] = useState([
    { label: "Extras", value: "Extras" },
    { label: "Toppings", value: "Toppings" },
    { label: "Scoope", value: "Scoope" },
  ]);



  const [menuMasterList, setMenuMasterList] = useState([]);

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  const [outletvalue, setOutletvalue] = useState({
    label: "",
    value: "",
  });

  const [menuSubmenuItems, setMenuSubmenuItems] = useState({
    outletCode: userDetails?.outletResponses[0]?.outletCode,
    status: "A",
    menuId: "",
    menuName: "",
    subMenuId: "",
    subMenuName: "",
    selectedSubmenuItem: "",
    selectedMainmenuItem: "",

    startTime: "",
    endTime: "",
    itemDesc: "",
    itemName: "",
    itemPrice: "",
    itemQuantity: "",
    itemType: "",
    itemFoodImage: "",
    itemFoodPath: "",
    varient: "",
    itemId: "",
    status: "",
  });


  const [selectedFoodSubmenuItem, setSelectedFoodSubmenuItem] = useState([]);

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const rootClass = expanded ? classes.rootExpanded : classes.root;
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [selectedOutlet, setSelectedOutlet] = useState(
    JSON.parse(localStorage.getItem("selectedOutlet"))
  );


  useEffect(() => {
    getMenuMasterListMasterApi();
  }, []);

  const getMenuMasterListMasterApi = async () => {
    let outletCode = userDetails?.outletResponses[0]?.outletCode;
    // console.log("vjdata", data);
    let getoutletList = await getMenuMasterList(outletCode);
    let getstaffListValue = getoutletList?.data?.data;
    console.log("getstaffListValue", getstaffListValue);

    setMenuMasterList(getstaffListValue, () => {
      
      console.log("menuMasterList123", menuMasterList);
      let outmaster = menuMasterList && menuMasterList.map(({ menuId, menuName }) => ({
        label: menuName,
        value: menuId,
      }));
      console.log("outmaster123", outmaster);
      setCategory(outmaster);
    });

  };

  const saveMenuSubmenu = async (key) => {
    let data = "";
    data = {
      outletCode: userDetails?.outletResponses[0]?.outletCode,
      status: "A",
      menuId: outletvalue?.value || "",
      menuName: menuSubmenuItems?.menuName || "",
      subMenuId: menuSubmenuItems?.subMenuId || "",
      subMenuName: menuSubmenuItems?.subMenuName || "",
    };
    let reqformenusubmenu;
    if (key === "Maninmenu") {
      reqformenusubmenu = await saveMainMenuName(data);
    } else if (key === "SubManinmenu") {
      reqformenusubmenu = await saveSubMenuName(data);
    } else {
    }


    if (reqformenusubmenu.data.status === true) {
      setMenuSubmenuItems({});

      setMainMenuModal(false)
      setSubMenuModal(false)
      setMenuFoodItemModal(false)

      getMenuMasterListMasterApi();
      // getstaffMasterList();     
      // setStaffvalue({});
      // setOutletvalue({});
      setIsview(false);
      setIsedit(false);
      // setLargeModal(!largeModal);

      if (key === "Maninmenu") {
        swal("Success!", "Menu Created", "success");
      } else {
        swal("Success!", "Sub Menu Updated", "success");
      }
    } else {
      // await this.setState({ reload: false });
      // NotificationManager.warning("Invalid Data Format");
      // this.setState({ addNewUserModal: true });

      setMainMenuModal(!mainMenuModal)
      getMenuMasterListMasterApi();

      swal("Oops", "Error, Please Try Later", "error");
      // setIsview(false);
      // setIsedit(false);
      // setLargeModal(!largeModal);
      // getstaffMasterList();
    }
  };


  const onChangeCommonpopup = (key, value) => {
    if (key != "itemFoodImage") {
      const newFormData = { ...menuSubmenuItems };
      newFormData[key] = value;
      setMenuSubmenuItems(newFormData);
    } else {
      const newFormData = { ...menuSubmenuItems };
      newFormData[key] = value.target.files[0];
      setMenuSubmenuItems(newFormData);
    }

  }


  function getSteps() {
    return ["Add Item Details", "Variant Item & Add-Ons"];
  }

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <FoodMenuForm menuSubmenuItems={menuSubmenuItems} onChangeCommonpopup={onChangeCommonpopup} />;

      case 1:
        return <VariantItemForm variant={variant} />;

      /* case 2:
        return <AddOnForm typeadd={typeadd} />; */
      /* case 3:
        return <BankDetails />; */
      /*  default:
        return "unknown step"; */
    }
  }

  const chkImgFile = (file) => {
    // console.log("file", file);
    if (file) {
      const fileArr = file.split(".");
      const fileExt = fileArr[fileArr.length - 1];
      if (fileExt.toLowerCase() == "pdf") {
        return false;
      } else {
        return true;
      }
    }
  };
  const skippedSteps = () => {
    return skipped.size;
  };
  const isStepOptional = (step) => {
    return step === 1 || step === 2;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleStep = (step) => {
    console.log("step", step);
    setActiveStep(step);
  };
  const totalSteps = () => {
    return getSteps().length;
  };
  const completedSteps = () => {
    return completed.size;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps() - skippedSteps();
  };

  const submitFoodItemApi = async () => {
    console.log("menuSubmenuItems", menuSubmenuItems)
    // setMenuFoodItemModal(false);
    let data = "";
    data = {
      outletCode: userDetails?.outletResponses[0]?.outletCode,
      status: "A",

      menuId: menuSubmenuItems?.menuId,
      menuName: menuSubmenuItems?.menuName,

      subMenuId: menuSubmenuItems?.subMenuId,
      subMenuName: menuSubmenuItems?.selectedSubmenuItem,

      startTime: menuSubmenuItems?.startTime,
      endTime: menuSubmenuItems?.endTime,
      itemDesc: menuSubmenuItems?.itemDesc,
      itemName: menuSubmenuItems?.itemName,
      itemPrice: menuSubmenuItems?.itemPrice,
      itemId: menuSubmenuItems?.itemId || "",
      itemQuantity: menuSubmenuItems?.itemQuantity,
      itemType: menuSubmenuItems?.itemType || "veg",

      itemFoodImage: menuSubmenuItems?.itemFoodImage,

      varient: [
        // {
        //   varientType: "",
        //   small: "",
        //   medium: "",
        //   large: ""
        // }
      ]
    };

    console.log("vjjv", data);
    let formData = new FormData();
    for (var key in data) {
      if (Array.isArray(data[key])) {
        data[key].forEach((obj, index) => {
          let keyName = [key, "[", index, "]"].join("");
          formData.append("file", obj);
        });
      } else {
        formData.append(key, data[key]);
      }
    }

    console.log("formData", formData);
    console.log("menuSubmenuItems?.itemId", menuSubmenuItems?.itemId);

    let reqformenusubmenu;
    if (menuSubmenuItems?.itemId == undefined) {
      reqformenusubmenu = await addOutletSubMenuItem(formData);
    } else {
      reqformenusubmenu = await UpdateOutletSubMenuItem(formData);
    }


    if (reqformenusubmenu.data.status === true) {
      if (menuSubmenuItems?.itemId == undefined) {
        swal("Success!", "Item Added", "success");
      } else {
        swal("Success!", "Item Updated", "success");
      }
      setMenuSubmenuItems({});
      setMenuFoodItemModal(false)
      getMenuMasterListMasterApi();

      setMainMenuModal(false)
      setSubMenuModal(false)
      setMenuFoodItemModal(false)


    } else {
      swal("Oops", "Error, Please Try Later", "error");
      setMenuFoodItemModal(false)
      getMenuMasterListMasterApi();

      setMainMenuModal(false)
      setSubMenuModal(false)
      setMenuFoodItemModal(false)

    }
  };

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );


  const onClose = () => {
    setMainMenuModal(!mainMenuModal);
  };



  const CloseImage = () => {
    setOpenImagePopup(!openImagePopup);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const renderItem = ({ item, collapseIcon, handler }) => {
    return (
      <div>
        {handler}
        {collapseIcon}
        {item.mainmenu}
      </div>
    );
  };


  const stylescheck = () => {
    let maxWidth = "";
    if (menuFoodItemModal) {
      return maxWidth == "500px";
    } else if (subMenuModal) {
      return maxWidth == "700px";
    } else {

    }
  }

  return (
    <>
      <h3 className="card-title">Menu Availablity -  {selectedOutlet?.label} </h3>
      <br />

      <div className="row">
        <div className="col-md-4">

          <Card>
            <Card.Header className="card-title">
              Category List {""}
              <Button variant="success dark btn-sm" onClick={() => {
                // setMenuFoodItemModal(false),
                //  setSubMenuModal(false),
                setMainMenuModal(true)
              }
              }>
                <i class="fas fa-plus">Menu </i>
              </Button>
              <br />
              <Button
                variant="success dark btn-sm"
                onClick={() => {

                  getMenuMasterListMasterApi();
                  // setMenuFoodItemModal(false),
                  setSubMenuModal(true)
                  // setMainMenuModal(true)
                }
                }>
                <i class="fas fa-plus">Sub-Menu</i>{" "}
              </Button>
            </Card.Header>
            <br />

            {menuMasterList && menuMasterList.map((cart, key) => {
              return <Accordion
                className={rootClass}
                // expanded={expanded === name}
                onChange={handleChange()}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography
                    style={{ color: "white", fontSize: "large" }}
                    onClick={() => {
                      setMenuSubmenuItems({
                        selectedMainmenuItem: cart?.menuName
                      });
                    }}
                  >
                    {cart?.menuName} </Typography>
                  {/* <i
                    style={{ paddingLeft: "175px", marginLeft: "0px", color: "black" }}
                    className="ti-plus"
                  ></i> */}
                </AccordionSummary>

                {cart?.subMenu && cart?.subMenu.map((items, index) => {
                  // 
                  // console.log("itemsvj", items)
                  // console.log("itemsvj", items?.subMenuName)
                  return <AccordionDetails>
                    <Typography style={{ color: "white", fontSize: "large" }}
                      onClick={() => {
                        // console.log("currentindex", index)
                        // console.log("currentindexitems", items?.subMenuName)
                        setMenuSubmenuItems({
                          selectedSubmenuItem: items?.subMenuName,
                          subMenuId: items?.subMenuId
                        });
                        setSelectedFoodSubmenuItem(items?.subMenuItem);
                      }}
                    >
                      {items?.subMenuName}
                    </Typography>
                    {/* <i
                      style={{ paddingLeft: "257px", color: "black", fontSize: "larger" }}
                      className="ti-plus"
                      onClick={() => {
                        setActiveStep(0);
                        setMenuFoodItemModal(true);
                        setMenuSubmenuItems({
                          selectedSubmenuItem: items?.subMenuName,
                          subMenuId: items?.subMenuId,
                          menuId: items?.menuId,
                          menuName: items?.menuName,
                          subMenuName: items?.subMenuName
                        })
                      }}
                    ></i> */}
                    <br />
                  </AccordionDetails>
                })}
              </Accordion>
            })}

            <br />

          </Card>
        </div>
        <div className="col-md-8">
          <Card>
            <Card.Header className="card-title">
              {/* Item Details */}
              {`Item Details -  ${menuSubmenuItems?.selectedMainmenuItem || ""}
                                ${menuSubmenuItems?.selectedSubmenuItem || ""}
                `}
              {/* // ${menuSubmenuItems?.selectedSubmenuItem || ""} */}
              <Button
                className="me-2"
                variant="success dark btn-sm"
                onClick={() => {
                  setMenuFoodItemModal(true);
                  setActiveStep(0);
                }}
              >
                <i class="fas fa-plus">Add Item</i>{" "}
              </Button>
            </Card.Header>
            <Card.Body>
              <Table responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>ITEM NAME</strong>
                    </th>
                    <th>
                      <strong>PRICE</strong>
                    </th>

                    <th>
                      <strong>TYPE</strong>
                    </th>

                    {/* <th>
                      <strong>QTY</strong>
                    </th> */}
                    {/* <th>
                      <strong>ITEM</strong>
                    </th> */}
                    <th>
                      <strong>ACTIONS</strong>
                    </th>
                  </tr>
                </thead>


                <tbody>
                  {selectedFoodSubmenuItem && selectedFoodSubmenuItem.length > 0
                    && selectedFoodSubmenuItem.map((items, index) => {
                      console.log("items?.subMenuId", items)
                      return <>
                        <tr>
                          <td>{items?.itemName}</td>
                          <td>{items?.itemPrice}</td>
                          <td>
                            <Badge variant="success light">Veg</Badge>
                          </td>
                          {/* <td>
                      {
                        <img
                          src={food1}
                          onClick={() => {
                            setOpenImagePopup(!openImagePopup);
                            setTempModalPopupValue(food1);
                          }}
                          width="40%"
                          height="40%"
                          target="blank"
                        ></img>
                      }
                    </td> */}
                          <td>
                            <i
                              onClick={() => {
                                console.log("items?.subMenuId", items?.subMenuId)
                                setMenuFoodItemModal(true)
                                setMenuSubmenuItems({
                                  selectedSubmenuItem: items?.itemName,
                                  startTime: items?.startTime || new Date(),
                                  endTime: items?.endTime || new Date(),
                                  itemDesc: items?.itemDesc,
                                  itemName: items?.itemName,
                                  itemPrice: items?.itemPrice,
                                  itemQuantity: items?.itemQuantity,
                                  itemType: items?.itemType,
                                  itemFoodPath: items?.itemFoodPath,
                                  itemFoodImage: items?.itemFoodImage,
                                  varient: items?.varient,
                                  itemId: items?.itemId,
                                  status: items?.status,
                                  subMenuId: items?.itemId,
                                  menuId: items?.menuId,
                                  menuName: items?.menuName
                                })
                              }
                              }
                              style={{ fontSize: "large" }}
                              className="ti-pencil"
                            ></i>
                          </td>
                        </tr>
                      </>
                    })}

                  {selectedFoodSubmenuItem && selectedFoodSubmenuItem.length <= 0
                    &&
                    <div>
                      <br />
                      No Data Found
                    </div>
                  }
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </div>
      </div>

      <Modal
        isOpen={mainMenuModal || subMenuModal || menuFoodItemModal || openImagePopup}
        toggle={() => onClose()}
        style={{ maxWidth: (menuFoodItemModal && "1000px" || subMenuModal && "700px") }}
        backdrop="static" >

        <ModalHeader>
          {mainMenuModal && "Add Main Menu" ||
            subMenuModal && "Add Sub Menu" ||
            menuFoodItemModal && `ADD ITEM - (${menuSubmenuItems?.selectedSubmenuItem})` ||
            openImagePopup && "View Food Image"
          }
          {menuFoodItemModal && <i
            className="ti-close"
            onClick={() => {
              setMenuFoodItemModal(false);
              setMenuSubmenuItems({
                selectedSubmenuItem: ""
              })
              // setMenuSubmenuItems ({});
              getMenuMasterListMasterApi();
            }}
            style={{ paddingLeft: "808px", color: "red", fontSize: "medium" }}
          ></i>
          }
        </ModalHeader>

        <ModalBody>
          {mainMenuModal &&
            <div className="row">
              <div className="col-sm-8 col-md-8 col-xl-8">
                <FormGroup>
                  <Label for="menu">
                    Main Menu Name
                    <span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="menu"
                    id="menu"
                    placeholder="Enter  Menu"
                    maxLength="40"
                    required
                    autoComplete="off"
                    onChange={(e) => {
                      // 
                      setMenuSubmenuItems(
                        {
                          menuName: e.target.value
                        }
                      )
                    }
                    }
                  />
                </FormGroup>
              </div>
            </div>}
          {subMenuModal &&
            <div className="row">
              <div className="col-sm-6 col-md-6 col-xl-5">
                <FormGroup>
                  <Label for="itemqty">
                    Menu Name<span class="text-danger">*</span>
                  </Label>
                  <Select
                    options={category}
                    search
                    name="stateCode"
                    placeholder="Choose Menu"
                    autoComplete="off"
                    value={outletvalue}
                    onChange={(event) => {
                      
                      console.log("event", event)
                      setOutletvalue({
                        label: event.label,
                        value: event.value
                      });
                    }}
                  />
                </FormGroup>
              </div>
              <div className="col-sm-6 col-md-6 col-xl-5">
                <FormGroup>
                  <Label for="submenu">
                    Sub Menu
                    <span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="submenu"
                    id="submenu"
                    placeholder="Enter Sub Menu"
                    maxLength="40"
                    required
                    autoComplete="off"

                    onChange={(e) => {
                      // 
                      setMenuSubmenuItems(
                        {
                          subMenuName: e.target.value
                        }
                      )
                    }}

                  />
                </FormGroup>
              </div>
            </div>}
          {menuFoodItemModal &&
            <>
              <Stepper
                alternativeLabel
                nonLinear
                className="stepper-rtl"
                activeStep={activeStep}
              >
                {steps.map((step, index) => {
                  const labelProps = {};
                  const stepProps = {};
                  if (isStepOptional(index)) {
                    labelProps.optional = (
                      <Typography
                        variant="caption"
                        align="center"
                        style={{ display: "block" }}
                      >
                        optional
                      </Typography>
                    );
                  }
                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={step} {...props}>
                      <StepButton onClick={() => handleStep(index)} {...stepProps}>
                        {step}
                      </StepButton>
                    </Step>
                  );
                })}
              </Stepper>
              <div className="pl-40">
                <p>{getStepContent(activeStep)}</p>
              </div>
            </>}

          {openImagePopup &&
            <>
              {tempModalPopupValue != "" ? (
                <>
                  {chkImgFile(tempModalPopupValue) ? (
                    <>
                      <a href={tempModalPopupValue} download target="_blank">
                        Download Image
                      </a>
                      <br />
                      <ReactPanZoom image={tempModalPopupValue} alt="image" />
                    </>
                  ) : (
                    <iframe
                      src={tempModalPopupValue}
                      width="100%"
                      height="400px"
                    ></iframe>
                  )}
                </>
              ) : (
                <p>File Not Available</p>
              )}
            </>
          }
        </ModalBody>

        <ModalFooter>

          {mainMenuModal &&
            <>
              <Button variant="primary"
                // disabled={!menuSubmenuItems?.subMenuName}
                onClick={() => { saveMenuSubmenu("Maninmenu") }} >Save</Button>

              <Button variant="danger light"
                onClick={() => {
                  // setMenuFoodItemModal(false),
                  //  setSubMenuModal(false),
                  setMainMenuModal(false)
                }
                }
              >
                Close
              </Button>
            </>}

          {subMenuModal &&
            <>
              <Button variant="primary" onClick={() => { saveMenuSubmenu("SubManinmenu") }} >Save</Button>
              <Button variant="danger light"
                onClick={() => {
                  // setMenuFoodItemModal(false),
                  setSubMenuModal(false)
                  // setMainMenuModal(false)
                }
                }
              >
                Close
              </Button>
            </>
          }

          {menuFoodItemModal &&
            <>
              {activeStep === 1 &&
                <Button
                  variant="secondary"
                  onClick={handleBack}
                >
                  Back
                </Button>}

              {activeStep === 0 ?
                <Button variant="primary" onClick={() => { setActiveStep(1) }}>
                  Save & Addons
                </Button> :
                <Button variant="primary" onClick={() => { submitFoodItemApi() }}>
                  Submit
                </Button>
              }

            </>
          }
        </ModalFooter>
      </Modal>
    </>
  );
};
export default MenuAvailablity;